import { z } from "zod/v4";

export const exclusionDateSchema = z.object({
	created_at: z.coerce.date(),
	date: z.coerce.date(),
	id: z.string().uuid(),
	reason: z.string(),
	season_id: z.string().uuid(),
});

export const createExclusionDatesSchema = z.object({
	dates: z.array(z.string()),
	reason: z.string(),
});
